﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("InfoService", function () {
    var registers = {};
    return {
      registerInfo: function (key, value) {
        registers[key] = value;
      },
      get: function (key) {
        return registers[key];
      },
    };
  });
})(window.angular);
